// src/assessment/data/questionBank.js

const questionBank = [
  /* ======================
     A1 – Very Easy
  ====================== */
  {
    id: 1,
    type: "grammar",
    level: "A1",
    difficulty: 1,
    question: "She ___ a teacher.",
    options: ["am", "is", "are", "be"],
    correctAnswer: 1,
  },
  {
    id: 2,
    type: "vocabulary",
    level: "A1",
    difficulty: 1,
    question: "What is the opposite of 'big'?",
    options: ["tall", "small", "long", "wide"],
    correctAnswer: 1,
  },
  {
    id: 3,
    type: "grammar",
    level: "A1",
    difficulty: 2,
    question: "They ___ football every weekend.",
    options: ["plays", "play", "playing", "played"],
    correctAnswer: 1,
  },
  {
    id: 4,
    type: "vocabulary",
    level: "A1",
    difficulty: 2,
    question: "Which one is a fruit?",
    options: ["carrot", "apple", "potato", "onion"],
    correctAnswer: 1,
  },
  {
    id: 5,
    type: "grammar",
    level: "A1",
    difficulty: 3,
    question: "I ___ from Egypt.",
    options: ["is", "are", "am", "be"],
    correctAnswer: 2,
  },

  /* ======================
     A2 – Easy
  ====================== */
  {
    id: 6,
    type: "grammar",
    level: "A2",
    difficulty: 1,
    question: "I ___ to London last year.",
    options: ["go", "went", "gone", "going"],
    correctAnswer: 1,
  },
  {
    id: 7,
    type: "vocabulary",
    level: "A2",
    difficulty: 1,
    question: "What does 'borrow' mean?",
    options: [
      "To give something",
      "To take something and return it later",
      "To lose something",
      "To buy something",
    ],
    correctAnswer: 1,
  },
  {
    id: 8,
    type: "grammar",
    level: "A2",
    difficulty: 2,
    question: "She is ___ than her sister.",
    options: ["tall", "taller", "tallest", "more tall"],
    correctAnswer: 1,
  },
  {
    id: 9,
    type: "vocabulary",
    level: "A2",
    difficulty: 2,
    question: "Choose the correct word: I'm very ___ today.",
    options: ["tired", "tiring", "tire", "tires"],
    correctAnswer: 0,
  },
  {
    id: 10,
    type: "grammar",
    level: "A2",
    difficulty: 3,
    question: "There isn't ___ milk left.",
    options: ["many", "much", "few", "a few"],
    correctAnswer: 1,
  },

  /* ======================
     B1 – Medium
  ====================== */
  {
    id: 11,
    type: "grammar",
    level: "B1",
    difficulty: 1,
    question: "If I ___ more time, I would travel more.",
    options: ["have", "had", "will have", "am having"],
    correctAnswer: 1,
  },
  {
    id: 12,
    type: "vocabulary",
    level: "B1",
    difficulty: 1,
    question: "What does 'manage to' mean?",
    options: [
      "To fail to do something",
      "To succeed in doing something",
      "To plan something",
      "To avoid something",
    ],
    correctAnswer: 1,
  },
  {
    id: 13,
    type: "grammar",
    level: "B1",
    difficulty: 2,
    question: "The email ___ by the manager yesterday.",
    options: ["is sent", "was sent", "has sent", "sent"],
    correctAnswer: 1,
  },
  {
    id: 14,
    type: "vocabulary",
    level: "B1",
    difficulty: 2,
    question: "Choose the closest meaning to 'improve'.",
    options: ["make worse", "make better", "keep same", "ignore"],
    correctAnswer: 1,
  },
  {
    id: 15,
    type: "grammar",
    level: "B1",
    difficulty: 3,
    question: "She asked me where I ___ from.",
    options: ["am", "was", "were", "be"],
    correctAnswer: 1,
  },

  /* ======================
     B2 – Hard
  ====================== */
  {
    id: 16,
    type: "grammar",
    level: "B2",
    difficulty: 1,
    question: "Not only ___ late, but he also forgot the documents.",
    options: ["he was", "was he", "he is", "is he"],
    correctAnswer: 1,
  },
  {
    id: 17,
    type: "vocabulary",
    level: "B2",
    difficulty: 1,
    question: "Choose the best collocation.",
    options: [
      "do a decision",
      "make a decision",
      "take a decision",
      "have a decision",
    ],
    correctAnswer: 1,
  },
  {
    id: 18,
    type: "grammar",
    level: "B2",
    difficulty: 2,
    question: "She ___ have known about the change.",
    options: ["must", "should", "would", "might"],
    correctAnswer: 0,
  },
  {
    id: 19,
    type: "vocabulary",
    level: "B2",
    difficulty: 2,
    question: "Which word is closest to 'reluctant'?",
    options: ["eager", "unwilling", "happy", "fast"],
    correctAnswer: 1,
  },

  /* ======================
     C1 – Very Hard
  ====================== */
  {
    id: 20,
    type: "grammar",
    level: "C1",
    difficulty: 1,
    question: "Had it not been for his help, we ___ failed.",
    options: ["will have", "would have", "had", "have"],
    correctAnswer: 1,
  },
  {
    id: 21,
    type: "vocabulary",
    level: "C1",
    difficulty: 1,
    question: "Choose the most precise word: Her comments were ___.",
    options: ["rude", "critical", "scathing", "negative"],
    correctAnswer: 2,
  },

  /* ======================
     C2 – Native Trap
  ====================== */
  {
    id: 22,
    type: "grammar",
    level: "C2",
    difficulty: 1,
    question:
      "I suggest that he ___ more careful in the future.",
    options: ["is", "was", "be", "being"],
    correctAnswer: 2,
  },
];

export default questionBank;


